module.exports = __webpack_public_path__ + "img/Social-1000Blocks-Telegram-Community.5f7d4ecb.png";